import React, { Component } from 'react';
import '../styles/App.css';
import { Container, Notification, Section, Navbar } from 'react-bulma-components';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import linkedin from '../assets/linkedin.png';
import github from '../assets/github.png';

class Header extends Component {
  render() {
    return (
      <header className="container-fluid header-wrapper">
        <Container>
          <Notification className="header-content container">
              <Section>
                <Section className="title">
                  <span>ND</span>
                </Section>
                <Section className="underlines"></Section>
                <Section className="hover-to-show">
                  <span className="">Nirmal Dandala</span>
                </Section>
              </Section>
              <Section className="contact-icons">
                <Section className="box">
                  <a href="https://www.linkedin.com/in/nirmaldandala/" target="_blank">
                    <img src={linkedin} width="40px" height="40px" />
                  </a>
                  <a href="https://github.com/nirmaldandalaio" target="_blank">
                    <img src={github} width="39px" height="39px" />
                  </a>
                </Section>
              </Section>
          </Notification>
        </Container>
      </header>
    );
  }
}

export default Header;